// assets
import { IconBuildingBank, IconUserSearch, IconDeviceDesktopAnalytics, IconCashOff } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconLoans: IconBuildingBank,
  IconLoanApplicant: IconUserSearch,
  IconLoanMonitoring: IconDeviceDesktopAnalytics,
  IconDisbursement: IconCashOff
};

// ==============================|| MENU ITEMS - LOANS ||============================== //

const loans: NavItemType = {
  id: 'loans',
  title: 'Loans',
  type: 'group',
  icon: icons.IconLoans,
  children: [
    {
      id: 'loan-applicants',
      title: 'Applicants',
      type: 'item',
      url: '/loans/applicants',
      icon: icons.IconLoanApplicant,
      breadcrumbs: false
    },
    {
      id: 'loan-monitoring',
      title: 'Loan Monitoring',
      type: 'item',
      url: '/loans/monitoring',
      icon: icons.IconLoanMonitoring,
      breadcrumbs: false
    },
    {
      id: 'disbursement',
      title: 'Disbursement',
      type: 'item',
      url: '/loans/disbursement',
      icon: icons.IconDisbursement,
      breadcrumbs: false
    }
  ]
};

export default loans;
